import React, { type ReactNode } from 'react';

import { cssMap } from '@atlaskit/css';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	root: {
		width: '100%',
		paddingTop: token('space.100'),
		paddingBottom: token('space.100'),
	},
});

type PanelProps = {
	children: ReactNode;
	testId?: string;
};

export const Panel: ({ children, testId }: PanelProps) => React.JSX.Element = ({
	children,
	testId,
}: PanelProps) => (
	<Stack space="space.100" xcss={styles.root} testId={testId}>
		{children}
	</Stack>
);
